import { Stack, Box, Typography, StackProps } from "@mui/material";
import logoImg from "src/images/passio-logo-tt.png";

interface Props extends StackProps {}

export const Logo = (props: Props) => {
    return (
        <Stack justifyContent="center" alignItems="center" gap={1.5} {...props}>
            <Box
                component="img"
                alt="logo"
                src={logoImg}
                sx={{
                    mx: "auto",
                    height: 150,
                    width: { xs: 250, md: "100%" },
                    objectFit: "contain",
                }}
            />

            <Typography
                component="h1"
                variant="h4"
                fontWeight="bold"
                fontSize={24}
                gutterBottom
                textTransform="uppercase"
            >
                Connect Rider
            </Typography>
        </Stack>
    );
};

export default Logo;
